import React, { useState, useRef } from 'react';
import { useOutsideAlerter } from '../useOutsideAlerter';
import { useNavigate } from 'react-router-dom';
import useApi from '../api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import toastConfig from '../config/Toast';
import { set } from 'lodash';

const NewTeamModal = ({ addTeam, showModal, setShowModal } : { addTeam: any, showModal: any, setShowModal: any }) => {
    const [newTeamName, setNewTeamName] = useState('');
    const [newTeamDescription, setNewTeamDescription] = useState('');

    const { get, getStream, post, postStream, put, patch, remove } = useApi();

    const navigate = useNavigate();

    const modalRef = useRef(null);
    useOutsideAlerter(modalRef, () => setShowModal(!showModal));

    const handleCreateTeam = async () => {
        try {

            // Ensure name is not empty
            if (!newTeamName) {
                toast.error('Team name cannot be empty', toastConfig);
                return;
            }
            // Call the create team API endpoint with the new team name
            const response = await post('/teams/', { name: newTeamName, description: newTeamDescription });
            // Add the newly created team to the teams list
            addTeam(response.data);
            // Reset the new team name input
            setNewTeamName('');
            setNewTeamDescription('');
            navigate('/teams/' + response.data.id);
            // Close the modal
            setShowModal(false);
            toast.success('Team created successfully', toastConfig);
        } catch (error) {
            console.error('Error creating team:', error);
            toast.error('Error creating team', toastConfig);
        }
    };


    return (
        <>
          {showModal && (
            <div className="grid place-content-center fixed inset-0 bg-gray-600 bg-opacity-50 backdrop-blur-sm overflow-y-auto h-full w-full z-50">
                <div ref={modalRef} className="relative w-96 bg-white rounded-lg p-8 mb-16">
                    <div className="flex flex-col">
                    <h2 className="text-xl font-bold mb-4">Create New Team</h2>
                    <input
                        type="text"
                        value={newTeamName}
                        onChange={(e) => setNewTeamName(e.target.value)}
                        placeholder="Enter team name"
                        className="border border-gray-300 rounded-lg p-2 mb-4"
                    />
                    <input
                        type="text"
                        value={newTeamDescription}
                        onChange={(e) => setNewTeamDescription(e.target.value)}
                        placeholder="Enter team description"
                        className="border border-gray-300 rounded-lg p-2 mb-4"
                    />
                    </div>
                    <div className="flex justify-between">
                    <button onClick={handleCreateTeam} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                        Create
                    </button>
                    <button onClick={() => setShowModal(false)} className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded ml-2">
                        Cancel
                    </button>
                    </div>
                </div>
            </div>
        )}
        </>
    );
};

export default NewTeamModal;